import { Input } from 'antd';
import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './styles.less';

const { Search } = Input;

const SliderRange = ({ format = '%', onChange, value, onClear }: any) => {
  const { t: translate } = useTranslation('inventory');

  const [valueFrom, setValueFrom] = useState(value && value[0]);
  const [valueTo, setValueTo] = useState(value && value[1]);

  const handleClearFilter = useCallback(() => {
    setValueFrom(undefined);
    setValueTo(undefined);
    onChange({
      valueFrom: undefined,
      valueTo: undefined,
    });
    onClear();
  }, [onChange, onClear]);

  return (
    <div>
      <div className="header-consumption-filter">
        <Search
          placeholder={translate('values-picker.from')}
          type="number"
          value={valueFrom}
          onChange={e => {
            if (e.target.value === '' || !e.target.value) {
              handleClearFilter();
            } else {
              setValueFrom(e.target.value);
            }
          }}
          onSearch={() => {
            onChange({ valueFrom, valueTo });
          }}
          suffix={format}
          allowClear
        />

        <Search
          type="number"
          placeholder={translate('values-picker.to')}
          value={valueTo}
          onChange={e => {
            if (e.target.value === '' || !e.target.value) {
              handleClearFilter();
            } else {
              setValueTo(e.target.value);
            }
          }}
          onSearch={() => {
            onChange({ valueFrom, valueTo });
          }}
          suffix={format}
          allowClear
        />
      </div>
    </div>
  );
};

export default SliderRange;
